// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTitle_container__23I7v","text":"PageTitle_text__1ma58","avatar":"PageTitle_avatar__3U3Z2"};